import { useMemo } from 'react';
import { PersistSettingsOptions } from '../..';
import { useGetPersistentDataGridSettings, usePutPersistentDataGridSettings } from './usePersistDataGridState';

export const useDataGridState = (persistOptions?: PersistSettingsOptions) => {
  if (!persistOptions || !persistOptions?.namespace || !persistOptions?.tableId || !persistOptions?.userId) {
    console.warn('No namespace, id, or userId provided, Data Grid settings not being persisted.');
  }

  const shouldPersist = useMemo(
    () =>
      !!persistOptions?.tableId &&
      !!persistOptions?.namespace &&
      !persistOptions?.disablePersistence &&
      !!persistOptions?.userId,
    [persistOptions],
  );

  const state =
    persistOptions && shouldPersist && persistOptions.userId
      ? useGetPersistentDataGridSettings(persistOptions.namespace, persistOptions.tableId, persistOptions?.userId)
      : undefined;

  const setState =
    persistOptions && shouldPersist && persistOptions.userId
      ? usePutPersistentDataGridSettings(persistOptions.namespace, persistOptions.tableId, persistOptions.userId)
      : undefined;

  return {
    state,
    setState,
    shouldPersist,
  };
};
